var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnexionSmallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 294,
    height: 98,
    viewBox: "0 0 294 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-1037 -889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 294,
    height: 98,
    transform: "translate(1037 889)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(818.4 -325.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(264.6 1276.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M273.276,1460.65v2.694h-5.654v5.185H264.6v-13.555h10.146v2.694h-7.124v2.98Z",
    transform: "translate(-264.6 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M329.481,1454.975H332.5v13.555h-3.021Z",
    transform: "translate(-317.278 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M363.9,1458.465h-.041v10.064h-2.919v-13.555h4.144l5.124,9.1h.041v-9.1h2.919v13.555h-3.634Z",
    transform: "translate(-342.823 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M445.462,1466.244h-6.226l-.919,2.286h-3.164l5.777-13.555h2.919l5.777,13.555h-3.246Zm-3.144-7.8-2.062,5.205h4.184l-2.082-5.205Z",
    transform: "translate(-404.81 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M524.259,1458.465h-.041v10.064H521.3v-13.555h4.144l5.124,9.1h.041v-9.1h2.919v13.555h-3.634Z",
    transform: "translate(-475.6 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M608.764,1454.951v3.307h-.143a4.778,4.778,0,0,0-3.879-1.674,4.287,4.287,0,1,0,0,8.574,4.746,4.746,0,0,0,3.879-1.674h.143v3.307a7.062,7.062,0,0,1-4.164,1.061c-4.328,0-7.247-2.9-7.247-6.981s2.919-6.982,7.247-6.982A6.874,6.874,0,0,1,608.764,1454.951Z",
    transform: "translate(-538.1 -1453.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M670.806,1454.975h3.021v13.555h-3.021Z",
    transform: "translate(-598.306 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M706.391,1466.244h-6.226l-.919,2.286h-3.164l5.777-13.555h2.919l5.777,13.555H707.31Zm-3.143-7.8-2.062,5.205h4.185l-2.082-5.205Z",
    transform: "translate(-619.317 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M782.231,1468.53v-13.555h3.021v10.86h6.839v2.694Z",
    transform: "translate(-690.016 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M875.6,1454.889v3.123h-.143a5.83,5.83,0,0,0-4.144-1.449c-1.49,0-2.429.571-2.429,1.49,0,.776.592,1.123,2.613,1.347,3.572.388,4.92,1.613,4.92,4.2,0,2.715-1.96,4.246-5.43,4.246a8.835,8.835,0,0,1-5.042-1.183v-3.124h.143a7.415,7.415,0,0,0,4.8,1.633c1.654,0,2.531-.511,2.531-1.49,0-.817-.633-1.184-2.694-1.409-3.491-.387-4.838-1.551-4.838-4.042,0-2.715,2.041-4.348,5.471-4.348A8.241,8.241,0,0,1,875.6,1454.889Z",
    transform: "translate(-758.782 -1453.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M941.713,1463h-5.655v2.838h7.124v2.694H933.037v-13.555h10.146v2.694h-7.124v2.8h5.655Z",
    transform: "translate(-813.966 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1002.891,1468.53H999.87v-13.555h6.083c3.389,0,5.124,1.511,5.124,4.43a3.827,3.827,0,0,1-2.837,4.1l3.245,5.022h-3.552l-2.756-4.715h-2.286Zm2.94-7.41c1.49,0,2.184-.551,2.184-1.714,0-1.184-.694-1.735-2.184-1.735h-2.94v3.45Z",
    transform: "translate(-868.949 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1069.771,1468.53l-5.348-13.555h3.246l3.613,9.656h.041l3.593-9.656h3.164l-5.349,13.555Z",
    transform: "translate(-922.092 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1146.229,1454.975h3.021v13.555h-3.021Z",
    transform: "translate(-990.838 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1184.761,1454.951v3.307h-.143a4.777,4.777,0,0,0-3.879-1.674,4.287,4.287,0,1,0,0,8.574,4.746,4.746,0,0,0,3.879-1.674h.143v3.307a7.062,7.062,0,0,1-4.164,1.061c-4.328,0-7.247-2.9-7.247-6.981s2.919-6.982,7.247-6.982A6.873,6.873,0,0,1,1184.761,1454.951Z",
    transform: "translate(-1012.857 -1453.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1255.479,1463h-5.655v2.838h7.124v2.694H1246.8v-13.555h10.146v2.694h-7.124v2.8h5.655Z",
    transform: "translate(-1072.495 -1454.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1320.205,1454.889v3.123h-.143a5.83,5.83,0,0,0-4.144-1.449c-1.49,0-2.429.571-2.429,1.49,0,.776.592,1.123,2.613,1.347,3.572.388,4.92,1.613,4.92,4.2,0,2.715-1.96,4.246-5.43,4.246a8.836,8.836,0,0,1-5.042-1.183v-3.124h.143a7.415,7.415,0,0,0,4.8,1.633c1.654,0,2.532-.511,2.532-1.49,0-.817-.633-1.184-2.694-1.409-3.491-.387-4.838-1.551-4.838-4.042,0-2.715,2.041-4.348,5.471-4.348A8.241,8.241,0,0,1,1320.205,1454.889Z",
    transform: "translate(-1124.201 -1453.889)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(264.884 1237.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M271.368,1248.638h-5.257v27.972h5.2v-18.432l7.226,12.58h3.916l7.223-12.58v18.432h5.2v-27.972h-5.252l-9.13,16.288Z",
    transform: "translate(-266.111 -1246.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M939.257,1248.638H933.9v27.972h18.424v-4.859H939.257Z",
    transform: "translate(-815.033 -1246.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 5.356,
    height: 27.971,
    transform: "translate(104.06 2.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 5.356,
    height: 27.971,
    transform: "translate(143.281 2.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1307.076,1271.75v-7.131h11.441v-4.753h-11.441v-6.317h12.839v-4.911h-18.2v27.971h18.2v-4.859Z",
    transform: "translate(-1117.367 -1246.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1165.288,1253.551v-4.913h-20.14v4.911h13.781l-14.5,18.2v4.859h20.889v-4.859h-14.26Z",
    transform: "translate(-989.66 -1246.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M469.158,1253.2a9.9,9.9,0,0,1,15.023-8.469v-6.008a15.356,15.356,0,0,0-19.889,18.7H470.1A9.856,9.856,0,0,1,469.158,1253.2Z",
    transform: "translate(-428.549 -1237.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M539.557,1308.275a9.9,9.9,0,0,1-15.023,8.469v6.008a15.355,15.355,0,0,0,19.889-18.7h-5.811A9.857,9.857,0,0,1,539.557,1308.275Z",
    transform: "translate(-478.562 -1291.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 5.771,
    height: 35.218,
    transform: "matrix(0.669, 0.743, -0.743, 0.669, 62.109, 2.09)",
    fill: "#f84300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M697.971,1261.9c2.6-.8,3.774-3.077,3.774-5.634,0-4.555-3.055-7.632-9.768-7.632H680.342v27.971h12.274c7.552,0,10.527-3.356,10.527-8.231A6.236,6.236,0,0,0,697.971,1261.9Zm-12.367-8.356h6.343c2.96,0,4.5.891,4.5,3.272,0,2.294-1.54,3.377-4.5,3.377H685.6Zm6.885,18.2H685.6v-7.438h6.885c3.418,0,5.044,1.247,5.044,3.772C697.533,1270.653,695.907,1271.75,692.489,1271.75Z",
    transform: "translate(-606.704 -1246.608)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnexionSmallLogo);
export default __webpack_public_path__ + "static/media/connexion-small-logo.cf6f2875daf10618fbcaa5d54a081b9a.svg";
export { ForwardRef as ReactComponent };